import { media, styled } from '@styles';
import { Container as StyledContainer } from '@components/templates/Container';

export const Wrapper = styled.div`
  & strong {
    font-weight: 600;
  }
  & em {
    font-style: italic;
  }
`;

export const Container = styled(StyledContainer)``;

export const Slices = styled.div`
  padding: 124px 0 200px;

  ${media.largeScreen`
    padding: 60px 0 160px;
  `}

  ${media.smallScreen`
    padding: 40px 0 96px;
  `}
`;

export const Other = styled.div``;

export const Title = styled.h1`
  font-weight: 300;
  font-size: ${(props) => props.theme.typography.h2FontSize};
  line-height: 140%;
  color: #2c2c2c;
  padding-top: 34px;
  padding-bottom: 34px;
  ${media.largeScreen`
    padding-top: 18px;
    padding-bottom: 18px;
    flex-direction: column;
  `}
  ${media.smallScreen`
    padding-top: 10px;
    padding-bottom: 10px;
  `}
`;

export const Information = styled.div`
  display: flex;
  ${media.mediumScreen`
    flex-direction: column;
  `}
`;

export const Images = styled.div`
  display: grid;
  column-gap: 20px;
  row-gap: 20px;
  width: 100%;
  max-width: 75%;
  grid-template-columns: 1fr 1fr;
  // flex-shrink: 0;
  margin-right: 40px; // project-img max-width of 66,66% - margin-right (86 / 2);

  .landscaped {
    grid-column: span 2;
    ${media.smallScreen`
      grid-column: 1;
    `}
  }

  ${media.mediumScreen`
    width: 100%;
    max-width: 100%;
    margin-right: 0;
    order: 1;
  `}
  ${media.smallScreen`
    grid-template-columns: 1fr;
  `}
  picture {
    display: inline-block;
    width: 100%;
  }
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const Content = styled.div`
  width: 100%;
  max-width: 25%; // project-data max-width of 33,33% - margin-right of project-img (86 / 2);

  ${media.mediumScreen`
    order: 1;
    max-width: 100%;
    margin-top: 18px;
  `}
`;
export const Description = styled.div`
  font-size: ${(props) => props.theme.typography.baseFontSize};
  color: #2c2c2c;
  p {
    font-family: ${(props) => props.theme.typography.extraFontFamily};
    font-size: ${(props) => props.theme.typography.baseFontSize};
    margin-bottom: 16px;
    color: ${(props) => props.theme.colors.graySemi};
    ${media.largeScreen`
      margin-bottom: 10px;
    `}
  }

  a {
    text-decoration: underline;
    color: ${(props) => props.theme.colors.blueLight};
  }

  b {
    font-weight: 600;
  }

  strong {
    color: ${(props) => props.theme.colors.red};
  }

  i {
    font-style: italic;
  }
`;

export const Attributes = styled.div`
  border-top: 1px solid rgba(#000000, 0.1);
  padding-top: 38px;
  margin-top: 30px;
  ${media.largeScreen`
    padding-top: 28px;
  `}
  ${media.smallScreen`
    padding-top: 18px;
    margin-top: 28px;
  `}
`;

export const AttributeItem = styled.div`
  display: flex;
  margin-bottom: 4px;
  ${media.largeScreen`
    margin-bottom: 2px;
  `}
  &:last-of-type {
    margin-bottom: 0;
  }
  &.align-end {
    align-items: flex-end;
  }
`;

export const AttributeName = styled.div`
  font-size: ${(props) => props.theme.typography.smallFontSize};
  line-height: 160%;
  color: #839098;
  white-space: nowrap;
`;

export const AttributeValue = styled.div`
  font-size: ${(props) => props.theme.typography.smallFontSize};
  line-height: 160%;
  color: #5b6870;
  margin-left: 10px;
  word-break: break-word;
`;

export const AttributeValueLink = styled(AttributeValue)`
  text-decoration: underline;
`;

export const Tags = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 28px -5px -5px;
  ${media.smallScreen`
    margin: 20px -5px -5px;
  `}
`;

export const TagItem = styled.div`
  display: inline-flex;
  align-items: center;
  height: 46px;
  border: 2px solid rgba(44, 44, 44, 0.1);
  box-sizing: border-box;
  border-radius: 55px;
  padding: 0 20px;
  font-size: ${(props) => props.theme.typography.smallFontSize};
  line-height: 100%;
  color: #2c2c2c;
  margin: 5px;
  ${media.largeScreen`
    height: 36px;
  `}
`;
